<template>
  <vs-popup
    :active.sync="isModalActive"
    @close="closeModal"
    title="Fotos e Arquivos"
    id="files-photos-modal"
  >
    <div class="flex items-center justify-start">
      <div v-if="loading">Carregando...</div>

      <div v-else-if="!loading && !listAttachments.length">
        Não há arquivos ou fotos para essa proposta
      </div>

      <div v-else>
        <GenericMultiplePreviews
          :files="parseListAttachments"
          :onDeletePreview="onDeletePreview"
        />
      </div>
    </div>
  </vs-popup>
</template>

<script>
import GenericMultiplePreviews from '../../components/generic/GenericMultiplePreviews.vue';
import services from '../../services';

export default {
  name: 'ModalMensagemFilesPhotos',
  props: {
    idPropostaNota: Number,
  },
  data() {
    return {
      isModalActive: false,
      idGetPropostaNota: null,
      loading: false,
      listAttachments: [],
      idToDelete: null,
    };
  },
  methods: {
    closeModal() {
      this.isModalActive = false;
    },
    async getAllAttachmentsPropostaNota() {
      try {
        this.listAttachments = [];
        this.loading = true;
        const model = 'propostas-notas-anexo';
        const action = `GetPropostasNotasAnexos/${this.idGetPropostaNota}`;
        const listAttachmentsPropostaNota = await services.getAll(
          model,
          {},
          action,
        );
        this.listAttachments = listAttachmentsPropostaNota.data;
      } catch {
        console.error('Não existe fotos ou arquivos para essa proposta.');
      } finally {
        this.loading = false;
      }
    },
    async onDeletePreview({ idPropostaNotasAnexos }) {
      try {
        this.loading = true;
        const model = 'propostas-notas-anexo';
        const action = `PropostasNotasAnexos/${idPropostaNotasAnexos}`;
        await services.delete(model, action, {});
        this.getAllAttachmentsPropostaNota();
      } catch {
        console.error('Não foi possível deletar esse arquivo.');
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    idPropostaNota: function (newIdProposta) {
      if (newIdProposta) {
        this.idGetPropostaNota = newIdProposta;
        this.getAllAttachmentsPropostaNota();
      }
    },
  },
  computed: {
    parseListAttachments() {
      const listAttachmentsWithoutDeleted = this.listAttachments
        .map(
          ({ linkAnexoS3, idPropostaNotasAnexos, createdAt, deletedAt }) => ({
            name: linkAnexoS3,
            idPropostaNotasAnexos,
            url: linkAnexoS3,
            date: createdAt,
            deletedAt,
          }),
        )
        .filter((item) => item.deletedAt === null);
      return listAttachmentsWithoutDeleted;
    },
  },
  components: { GenericMultiplePreviews },
};
</script>

<style lang="css"></style>
